// extracted by mini-css-extract-plugin
module.exports = {"preview":"Preview_preview__TLhQL","top":"Preview_top__1SrzZ","icon":"Preview_icon__1xYox","text":"Preview_text__1Uo6F","button":"Preview_button__2ZuiQ"};